<div class="grid grid-cols-3 gap-[29px] pt-[38px] text-white">
    @for (element of menuElements; track $index){
    <a href="{{element.route}}">
        <div class="col-span-1 menu-gradient rounded-lg px-[10px] py-[22px] h-full text-white">
            <div class="w-full h-[24px] lg:text-left text-center mb-[10px]"><fa-icon [icon]="element.icon" size="xl"/></div>
            <div class="flex flex-row w-full min-h-[39px] lg:text-left text-center lg:justify-start justify-center text-[18px] lg:text-[30px] lg:mb-[20px] font-[DMSans] lg:font-bold items-center lg:items-start shrink-0">{{element.title}}</div>
            <div class="hidden lg:block w-full font-[DMSans] text-[16px]">{{element.text}}</div>
        </div>
    </a>
    }
</div>